export enum PERMISSIONS {
    // Intune user permissions
    INTUNE_USER_READ = 'intune_user_read',
    INTUNE_USER_RESET_PASSWORD = 'intune_user_reset_password',

    // Device permissions
    DEVICE_READ = 'device_read',
    DEVICE_FRESH_START = 'device_fresh_start',
    DEVICE_WIPE = 'device_wipe',
    DEVICE_RETRIEVE_BITLOCKER = 'device_retrieve_bitlocker',
    DEVICE_AUTOPILOT_RESET = 'device_autopilot_reset',
    DEVICE_LOCAL_CREDENTIAL_RESET = 'device_local_credential_reset',

    // User management
    USER_READ = 'user_read',
    USER_CREATE = 'user_create',
    USER_EDIT = 'user_edit',
    USER_DELETE = 'user_delete',

    // Role management
    ROLE_READ = 'role_read',
    ROLE_CREATE = 'role_create',
    ROLE_EDIT = 'role_edit',
    ROLE_DELETE = 'role_delete',

    // Autopilot device management
    AUTOPILOT_DEVICES_READ = 'autopilot_devices_read',
    AUTOPILOT_DEVICES_IMPORT = 'autopilot_devices_import',
    AUTOPILOT_DEVICES_DELETE = 'autopilot_devices_delete',

    // Reports
    ANOMALIES_REPORT = 'anomalies_report',
    ENTRA_ADMIN_REPORT = 'entra_admin_report',
    M365_LICENSE_REPORT = 'm365_license_report',

    // Billing
    BILLING_MANAGE = 'billing_manage',

    // Licences
    LICENSE_MANAGE = 'license_manage',
}

export const SETTINGS_PERMISSIONS: PERMISSIONS[] = [
    PERMISSIONS.USER_READ,
    PERMISSIONS.USER_CREATE,
    PERMISSIONS.USER_EDIT,
    PERMISSIONS.USER_DELETE,
    PERMISSIONS.ROLE_READ,
    PERMISSIONS.ROLE_CREATE,
    PERMISSIONS.ROLE_EDIT,
    PERMISSIONS.ROLE_DELETE,
    PERMISSIONS.BILLING_MANAGE,
    PERMISSIONS.LICENSE_MANAGE,
];

export const DEVICE_ACTION_PERMISSIONS = [
    PERMISSIONS.DEVICE_FRESH_START,
    PERMISSIONS.DEVICE_WIPE,
    PERMISSIONS.DEVICE_RETRIEVE_BITLOCKER,
    PERMISSIONS.DEVICE_AUTOPILOT_RESET,
    PERMISSIONS.DEVICE_LOCAL_CREDENTIAL_RESET,
];

export const REPORTS_PERMISSIONS = [
    PERMISSIONS.ANOMALIES_REPORT,
    PERMISSIONS.ENTRA_ADMIN_REPORT,
    PERMISSIONS.M365_LICENSE_REPORT,
];